import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderExecutionDetail extends BaseModelAPI {
	static entity = 'workorderexecutiondetail';
	static entityName = 'workorderexecutiondetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.workOrderExecutionId = '';
			this.workOrderExecution = {};
			this.workOrderProcessDetailId = '';
			this.workOrderProcessDetail = {};
			this.partId = '';
			this.part = {};
			this.goodQty = 0;
			this.pendingQty = 0;
			this.totalQty = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}